import React from 'react';
import { UnifiedAvatar } from '@/components/shared/UnifiedAvatar';
import { cn } from '@/lib/utils';

interface BoostedProfileCircleProps {
  userId: string;
  username: string;
  photoUrl: string | null;
  onClick: () => void;
  isPlaceholder?: boolean;
}

export const BoostedProfileCircle: React.FC<BoostedProfileCircleProps> = ({
  userId,
  username,
  photoUrl,
  onClick,
  isPlaceholder = false
}) => {
  if (isPlaceholder) {
    return (
      <div className="flex flex-col items-center gap-1 min-w-[60px]">
        <div className="w-14 h-14 rounded-full bg-white/5 border-2 border-white/10 flex items-center justify-center">
          <span className="text-white/20 text-lg">?</span>
        </div>
        <span className="text-[10px] text-white/30 truncate max-w-[60px]">
          Em breve
        </span>
      </div>
    );
  }

  return (
    <button
      onClick={onClick}
      className="flex flex-col items-center gap-1 min-w-[60px]"
    >
      <div
        className={cn(
          'w-14 h-14 rounded-full p-[2px]',
          'bg-gradient-to-br from-luxury-pinkBright via-purple-500 to-luxury-pinkBright',
          'hover:scale-105 active:scale-95 transition-transform'
        )}
      >
        <div className="w-full h-full rounded-full overflow-hidden bg-black">
          <UnifiedAvatar
            src={photoUrl}
            alt={username}
            size="medium"
            fallback={username?.slice(0, 2).toUpperCase()}
          />
        </div>
      </div>
      <span className="text-[10px] text-white/60 truncate max-w-[60px]">
        {username}
      </span>
    </button>
  );
};
